import { AppRoutes } from './pages/Routes';
import './i18n';
import { Amplify } from 'aws-amplify';
import { awsCognitoConfig } from './features/auth/components/awsCognitoConfig';

Amplify.configure(awsCognitoConfig);

function App() {
  return <AppRoutes />;
}

export default App;
